import { z } from 'zod';
import { ISTQBChapterRefSchema } from './ticket.schema';

export const ByChapterScoreSchema = z.record(
  ISTQBChapterRefSchema,
  z.object({
    correct: z.number().int(),
    total: z.number().int(),
    pct: z.number(),
  }),
);

export const MockResultSchema = z.object({
  bankId: z.string(),
  correct: z.number().int(),
  total: z.number().int(),
  pct: z.number(),
  byChapter: ByChapterScoreSchema,
  submittedAt: z.string(),
  durationSec: z.number().int(),
});

export const MockHistorySchema = z.object({
  mock1: MockResultSchema.optional(),
  mock2: MockResultSchema.optional(),
});

export const FlashcardStateSchema = z.object({
  termId: z.string(),
  ef: z.number(),
  intervalDays: z.number(),
  reps: z.number().int(),
  lastReviewAt: z.string(),
  nextDueAt: z.string(),
});

export const CockpitStateSchema = z.object({
  examDate: z.string().optional(),
  mockHistory: MockHistorySchema,
  flashcards: z.record(z.string(), FlashcardStateSchema),
  /**
   * Block-1 «Перевал» exam result (S01-S05 · bank `block1-exam`) · slot BLOCK1_EXAM.
   * Same shape as a MockResult (carries byChapter for the CTFL-readiness diagnostic
   * that S06 picks up). Optional — absent for learners who haven't taken it.
   */
  blockExamResult: MockResultSchema.optional(),
  /**
   * Результаты экзаменов-вех по bankId (block1-exam / block2-exam / block3-exam) ·
   * checkpoint_exams_spec. Каждая веха хранит свой результат отдельно, чтобы бейдж
   * «сдан» одной не затирался следующей. `blockExamResult` выше оставлен для обратной
   * совместимости (последняя сданная веха · S06-диагностика читает его).
   */
  blockExamResults: z.record(z.string(), MockResultSchema).optional(),
});

export type ByChapterScore = z.infer<typeof ByChapterScoreSchema>;
export type MockResult = z.infer<typeof MockResultSchema>;
export type MockHistory = z.infer<typeof MockHistorySchema>;
export type FlashcardState = z.infer<typeof FlashcardStateSchema>;
export type CockpitState = z.infer<typeof CockpitStateSchema>;
